import {doConsentAction, openPrivacyCenter} from '@consent/scripts/modules/consent-functions.js';

window.doConsentAction = doConsentAction;
window.openPrivacyCenter = openPrivacyCenter;
